// Indian-numbering-system rupees to words (Lakh/Crore)
// Handles integers 0..99,99,99,99,99 and decimal paise
const ONES = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
  "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
const TENS = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

function twoDigits(n) {
  if (n < 20) return ONES[n];
  const t = Math.floor(n / 10);
  const o = n % 10;
  return TENS[t] + (o ? " " + ONES[o] : "");
}

function threeDigits(n) {
  const h = Math.floor(n / 100);
  const rest = n % 100;
  const parts = [];
  if (h) parts.push(ONES[h] + " Hundred");
  if (rest) parts.push(twoDigits(rest));
  return parts.join(" ");
}

export function numberToIndianWords(input) {
  if (input === "" || input === null || input === undefined) return "";
  const num = Number(String(input).replace(/[^\d.-]/g, ""));
  if (!isFinite(num)) return "";
  if (num === 0) return "Zero Rupees";
  const negative = num < 0;
  const abs = Math.abs(num);
  const rupees = Math.floor(abs);
  const paise = Math.round((abs - rupees) * 100);

  const parts = [];
  const crore = Math.floor(rupees / 10000000);
  const lakh = Math.floor((rupees % 10000000) / 100000);
  const thousand = Math.floor((rupees % 100000) / 1000);
  const rest = rupees % 1000;

  if (crore) parts.push((crore > 99 ? threeDigits(crore) : twoDigits(crore)) + " Crore");
  if (lakh) parts.push(twoDigits(lakh) + " Lakh");
  if (thousand) parts.push(twoDigits(thousand) + " Thousand");
  if (rest) parts.push(threeDigits(rest));

  let out = parts.join(" ").replace(/\s+/g, " ").trim() + " Rupees";
  if (paise) out += " and " + twoDigits(paise) + " Paise";
  if (negative) out = "Minus " + out;
  return out;
}
